import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

export interface CrmFormData {
  personName: string;
  email: string;
  gymName: string;
  gymAddress: string;
  contactNumber: string;
}

@Injectable()
export class CrmPostService {
  private crmUrlPost = 'https://oysteer.companyhub.com/WebToLead/New';
  private redurectUrl = 'https://www.gogymbuddy.com/Thankyou.html';
  private token = 'DfmdBhlz+1fAlds4Ze0dng==';
  private ownerId = '-1';
  private table = 'Contact';

  private httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'max-age=0',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    })
  }

  constructor(private http: HttpClient) { }

  postToCrm(data: CrmFormData): Observable<any> {
    const input = new FormData();
    // input.append('redirecturl', this.redurectUrl);
    input.append('ownerid', this.ownerId);
    input.append('token', this.token);
    input.append('table', this.table);
    input.append('Name', data.personName);
    input.append('Email', data.email);
    input.append('Company', data.gymName);
    input.append('City', data.gymAddress);
    input.append('Phone', data.contactNumber);

    return this.http.post(this.crmUrlPost, input, this.httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/crm-post.service.ts